import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import HistoryTransactionList from "./HistoryTransactionList"
import { useLocation } from "react-router-dom";
import TransactionAppointmentPopup from "./TransactionAppointmentPopup";
import data from "../../assets/apiRoutes.json";
import TransactionDetail from "./TransactionDetail";
import * as PermissionsConstants from "../../const/constants";
import TransactionSerialNumberManifest from "./TransactionSerialNumberManifest";
import TransactionSchedulingPopUp from "./TransactionSchedulingPopUp";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getAppSettings, GetDateTimeStandardFormat } from "../../common/Utils";
import _ from "lodash";
import TransactionFormField from "./TransactionFormField";
import { Statuses } from "../../enum/Enum";

const HistorySearchForm = (props) => {
    const location = useLocation();
    const [disable, setDisable] = useState(true);
    const [disableEditDelete, setDisableEditDelete] = useState(false);
    var accessToken = props.oidc.user.access_token;
    const [showIcon, setShowIcon] = React.useState(getAppSettings()?.FiltersCollapsed? false : true);
    const [stateSerialNumbPopUp, setStateSerialNumbPopUp] = useState(false);
    const [deleteTransactionnumber, setDeletTransactionnumber] = useState(null);
    const [transactionRowId, setTransactionRowId] = useState("");
    const [stateTransSchedulingPopUp, setStateTransSchedulingPopUp] =
        useState(false);
    const [stateTransAppointmentPopUp, setStatestateTransAppointmentPopUp] =
        useState(false);
    const [transactionType, setTransactionType] = useState({
        transactionType:
            props.permission === PermissionsConstants.HistoryReadReceipts
                ? "R"
                : props.permission === PermissionsConstants.HistoryReadAdjustments
                    ? "A"
                    : "S",
        dbName:
            props.ReceiptReducer.wmTransactionDatabase !== ""
                ? props.ReceiptReducer.wmTransactionDatabase
                : "",
    });
    const setSearchPanelStatus = (v) => {
        setShowIcon(v);
    };

    const handleClickOpenTransSchedulingDialogue = () => {
        if (transactionRowId) setStateTransSchedulingPopUp(true);
    };
    const handleCloseSchedulingPopUpCallback = (ChildData) => {
        setStateTransSchedulingPopUp(ChildData);
    };
    const handleClickOpenTransAppointmentDialogue = () => {
        if (transactionRowId) setStatestateTransAppointmentPopUp(true);
    };
    const handleCloseAppointmentPopUpCallback = (ChildData) => {
        setStatestateTransAppointmentPopUp(ChildData);
    };

    const handleClickOpenDialogue = () => {
        if (transactionRowId) setStateSerialNumbPopUp(true);
    };
    const [dataSource, setDataSource] = useState(null);
    const searchData = (data) => {
       setDataSource(data);
    }
    const resetSearchedData = () => {
    };
    const handleCallback = (childData) => {

        setTransactionRowId(childData.rowid);
        setDeletTransactionnumber(childData.transactionnumber);
        var disableEditDelete = childData.isAssociatedCustomerTrans;
        if (!disableEditDelete && (transactionType.transactionType == "R" || transactionType.transactionType == "S")) {
            var stage = childData.stageFlag;
            var editDelFromStage = "R";
            if (transactionType.transactionType == "R" && props.oidc.user.profile.hasOwnProperty("RECEDITDELFROMSTAGE")) {
                editDelFromStage = props.oidc.user.profile.RECEDITDELFROMSTAGE;
            }
            else if (transactionType.transactionType == "S" && props.oidc.user.profile.hasOwnProperty("SHIPEDITDELFROMSTAGE")) {
                editDelFromStage = props.oidc.user.profile.SHIPEDITDELFROMSTAGE;
            }
            switch (stage) {
                case "P":
                    if (editDelFromStage == 'P') {
                        disableEditDelete = true;
                    }
                    break;
                case "F":
                    if (editDelFromStage == 'P' || editDelFromStage == 'F') {
                        disableEditDelete = true;
                    }
                    break;
                case "N":
                    if (editDelFromStage == 'P' || editDelFromStage == 'F' || editDelFromStage == 'N') {
                        disableEditDelete = true;
                    }
                    break;
                case "R":
                    if (editDelFromStage == 'P' || editDelFromStage == 'F' || editDelFromStage == 'N' || editDelFromStage == 'R') {
                        disableEditDelete = true;
                    }
                    break;
                case "C":
                    disableEditDelete = true;
                    break;
            }
        }

        setDisable(false);
        setDisableEditDelete(disableEditDelete);
    };
    const transactionCallbackOnUnCheck = () => {
        setDisable(true);
    };
   
    const handleClosePopUpCallback = (ChildData) => {
        setStateSerialNumbPopUp(ChildData);
    };
    //End:Call back Funtions
  
    return (
        <div>
            <Switch>
                <Route exact path="/wm/history">
                 <TransactionFormField
                   permission={props.permission}
                   resetQueryForm={resetSearchedData}
                   setSearchPanelStatus={setSearchPanelStatus}
                   searchData={searchData}
                   statusFlag={Statuses.History}
                   transactionType = {transactionType.transactionType}
                 />
                </Route>
                <Route
                    path={
                        props.permission === PermissionsConstants.HistoryReadReceipts
                            ? "/wm/history/view-receipt"
                            : props.permission ===
                                PermissionsConstants.HistoryReadAdjustments
                                ? "/wm/history/view-receipt"
                                : "/wm/history/view-shippment"
                    }
                >
                    <TransactionDetail isTransItmsOnly={true}
                        transRowid={transactionRowId}
                        GotoScreen={PermissionsConstants.HistoryScreen}
                        resetQueryForm={resetSearchedData}
                        transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
                    />
                </Route>
               
            </Switch>
            {location.pathname === "/wm/history/view-receipt" ? (
                ""
            ) : location.pathname === "/wm/history/view-shippment" ? (
                ""
            ) : (
                <HistoryTransactionList
                    disable={disable}
                    disableEditDelete={disableEditDelete}
                    deletedTransactionNumber={deleteTransactionnumber}
                    rowid={transactionRowId}
                    loadTransactions={resetSearchedData}
                    permission={props.permission}
                    data={dataSource}
                    tabsValue={props.permission}
                    transactionCallback={handleCallback}
                    transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
                    SearchPanelAccordionStatus={showIcon}
                    handleClickOpenDialogue={handleClickOpenDialogue}
                    handleClickOpenTransAppointmentDialogue={handleClickOpenTransAppointmentDialogue}
                    handleClickOpenTransSchedulingDialogue={handleClickOpenTransSchedulingDialogue}
                />
            )}
            {stateSerialNumbPopUp && (
                <TransactionSerialNumberManifest
                    transRowid={transactionRowId}
                    visibility={stateSerialNumbPopUp}
                    parentCallback={handleClosePopUpCallback}
                ></TransactionSerialNumberManifest>
            )}
            {stateTransAppointmentPopUp && (
                <TransactionAppointmentPopup
                    transRowid={transactionRowId}
                    visibility={stateTransAppointmentPopUp}
                    parentCallback={handleCloseAppointmentPopUpCallback}
                ></TransactionAppointmentPopup>
            )}
            {stateTransSchedulingPopUp && (
                <TransactionSchedulingPopUp
                    transRowid={transactionRowId}
                    visibility={stateTransSchedulingPopUp}
                    parentCallback={handleCloseSchedulingPopUpCallback}
                ></TransactionSchedulingPopUp>
            )}
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistorySearchForm);
